import styled from 'styled-components';
import EditableArea from '../EditableArea';

export const StyledEditableArea = styled(EditableArea)`
  min-width: 70px;
  width: fit-content;
`;
